export function getCustomerCountryCode(customer = {}) {
  const address = [
    customer["Bill to Address"],
    customer.Address,
  ].filter(Boolean).join(" ").toUpperCase();

  if (/\bCANADA\b|\bCANADIAN\b/.test(address)) return "CA";
  if (/\bUSA\b|\bUNITED STATES\b|\bU\.S\.A\.?\b/.test(address)) return "US";

  const configured = String(customer.Available_Country || "")
    .trim().toUpperCase();
  if (["CA", "CAN", "CANADA"].includes(configured)) return "CA";
  if (["US", "USA", "UNITED STATES"].includes(configured)) return "US";

  const currency = String(customer.Currency || "").trim().toUpperCase();
  if (currency === "CAD") return "CA";
  if (currency === "USD") return "US";
  return "OTHER";
}
